"use client";

import { HallowABFlag } from "../types/enums/HallowABFlag.enum";
import { useMixpanel } from "./useMixpanel";

export const useContinueButtonProps = () => {
  const { flags } = useMixpanel();

  if (flags?.[HallowABFlag.WebBiggerContinueButtons]?.isTargeted) {
    return {
      textProps: {
        type: "title",
        size: "xl",
      },
      size: "l",
      style: { height: "74px" },
    } as const;
  }

  return {};
};
